// @docs:
//   - docs/core/architecture/SHIPS_PAPERS.md
// ==============================================
// /join/<token> → /dashboard/join/<token>
// ==============================================
//
// Vessel invitation emails sent before 2026-09-25 link to /join/<token>, but
// the join page lives under the signed-in dashboard. This keeps those links
// working; new emails link to /dashboard/join/<token> directly. `replace` so
// Back does not return to the bare address.

import { Navigate, useParams } from 'react-router-dom';

export function JoinRedirect() {
  const { token = '' } = useParams();
  return <Navigate to={`/dashboard/join/${encodeURIComponent(token)}`} replace />;
}
